import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { CartType } from '../../../../core/model';
import { FullPalletUpgrade } from '../../../../core/occ/occ-models/occ-generated.models';
import { Occ } from '../../../../core/occ/occ-models/occ.models';

@Injectable({
  providedIn: 'root',
})
export class FullPalletUpgradeConnector {
  constructor(private httpClient: HttpClient, private occEndpointsService: OccEndpointsService) {}

  load(userId: string, cartType: CartType, entryNumber: string): Observable<FullPalletUpgrade> {
    const url = this.occEndpointsService.buildUrl('fullPalletUpgrade', {
      urlParams: {
        userId: userId,
        cartCodeOrType: cartType,
        entryNumber,
      },
    });

    return this.httpClient.get<Occ.FullPalletUpgrade>(url);
  }
}
